export const apiPrefix = (url: string): string => {
  return url.split('/api').length === 1 ? `/api${url}` : url
}
